<div fxLayout="column" ngStyle.lt-md="padding: 0 1rem;">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else noteRepayScheduleListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="noteRepayScheduleListFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #noteRepayScheduleListFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
      <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxLayout="column" *ngIf="!showSpinner">
      <div *ngIf="isBrowserIE; else noteRepayScheduleListTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="noteRepayScheduleListTableFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noteRepayScheduleListTableFlexColumnTemplate>
  <div fxFlex="100%" class="display-text primary-dark-color-important">
    <b><span i18n="@@note-repay-schedule-list.table.title">note-repay-schedule-list.table.title</span></b>
  </div>

  <div fxFlex="100%" class="display-text title-spacer" *ngIf="!notesRepayScheduleListFound">
    <i><span i18n="@@note-repay-schedule-list.table.no-records">note-repay-schedule-list.table.no-records</span></i>
  </div>

  <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
    <mat-table #table [dataSource]="tableDataSource" class="primary-lightest-bg" ngClass.lt-md="small-table-text">
      <!-- numberOfPayments Column -->
      <ng-container matColumnDef="numberOfPayments">
        <mat-header-cell *matHeaderCellDef fxFlex="30%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@note-repay-schedule-list.table.column-header.number-of-payments"
            >note-repay-schedule-list.table.column-header.number-of-payments</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="30%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.numberOfPayments
        }}</mat-cell>
      </ng-container>
      <!-- paymentAmount Column -->
      <ng-container matColumnDef="paymentAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="30%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@note-repay-schedule-list.table.column-header.payment-amount"
            >note-repay-schedule-list.table.column-header.payment-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="30%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.paymentAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- effectiveDate Column -->
      <ng-container matColumnDef="effectiveDate">
        <mat-header-cell *matHeaderCellDef fxFlex="40%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@note-repay-schedule-list.table.column-header.effective-date"
            >note-repay-schedule-list.table.column-header.effective-date</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="40%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.effectiveDate | date: 'MM/dd/yyyy'
        }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="tableDisplayedColumns" ngClass.lt-md="small-header-row"></mat-header-row>
      <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"></mat-row>
    </mat-table>
  </div>
  <div>
  <div fxFlex="100%" class="display-text primary-dark-color-important" *ngIf="notesRepayScheduleListFound">
    <span i18n="@@note-repay-schedule-list.total-paymnts-require.label">note-repay-schedule-list.total-paymnts-require.label</span>:&nbsp;{{
      var_total_payments
    }}
  </div>
  <div fxFlex="100%" fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="notesRepayScheduleListFound">
    <app-table-record-count
      [recordCount]="notesRepayScheduleList.length"
      i18n-singularLabel="@@note-repay-schedule-list.table.record-count.singular-label"
      singularLabel="note-repay-schedule-list.table.record-count.singular-label"
      i18n-multipleLabel="@@note-repay-schedule-list.table.record-count.multiple-label"
      multipleLabel="note-repay-schedule-list.table.record-count.multiple-label"
    ></app-table-record-count>
  </div></div>
</ng-template>
